import { ErrorParser } from "../ErrorParser";
import { isObject } from "lodash-es";

/**
 * Ej: Invalid combo
 */
export class EncuestaInvalidaParser implements ErrorParser {
    public puedeLeerError(error: string): boolean {
        return !isObject(error) && error.includes("Invalid combo");
    }

    public traducir(): string {
        return "El combo no existe";
    }
}
